import { z } from "zod";

export const RouteGetCdtTrees_treeId_ = "/cdt/trees/:treeId";

export const CdtTreeNodeSchema = z.object({
  id: z.number(),
  parentNodeId: z.number().nullable(),
  level: z.number(),
  name: z.string(),
  subdivisionField: z.string().nullable(),
  priority: z.number().nullable(),
  displayOrder: z.number().nullable(),
  itemCount: z.number(),
});

export const CdtTreeMetaSchema = z.object({
  id: z.number(),
  categoryId: z.number(),
  categoryName: z.string(),
  name: z.string(),
  isUserModified: z.boolean(),
  isReadOnly: z.boolean(),
  isCategoryDefault: z.boolean(),
  sourceRevision: z.string().nullable(),
  lastModifiedSource: z.enum(["etl", "user_edit"]),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const ResponseGetCdtTreeSchema = z.object({
  tree: CdtTreeMetaSchema,
  nodes: z.array(CdtTreeNodeSchema),
});

export type ResponseGetCdtTree = z.infer<typeof ResponseGetCdtTreeSchema>;
export type CdtTreeMeta = z.infer<typeof CdtTreeMetaSchema>;
export type CdtTreeNode = z.infer<typeof CdtTreeNodeSchema>;
